/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input, OnInit } from '@angular/core';
import { Tour } from '@shared/models';

@Component({
    selector: 'app-barcode',
    templateUrl: './barcode.component.html',
    styleUrls: ['./barcode.component.scss'],
    standalone: false
})
export class BarcodeComponent {
  @Input() tour: Tour;
}
